import { RootState } from 'gf-types';
import { getIn } from '../helpers/helpers';
import { Form } from '../types/form-types';
import { Template, TemplateField } from '../types/template-types';
import { SendAForm } from './formeditor-types';

export const getFieldKeyPathById = (template: Template, fieldId: string) => {
  const fieldIndex = template.fields.findIndex((f) => {
    return f.id === fieldId;
  });
  if (fieldIndex === -1) {
    return null;
  }

  return ['fields', fieldIndex];
};

export const getFieldIdByName = (template: Template, fieldName: string): string => {
  const field = template.fields.find((f: TemplateField) => {
    return f.name === fieldName;
  });
  if (!field) {
    return null;
  }
  return field.id;
};

export const getField = (template: Template, fieldId: string): TemplateField => {
  const keyPath = getFieldKeyPathById(template, fieldId);
  if (!keyPath) {
    return null;
  }
  return getIn(template, keyPath);
};

export const getValueKeyPathByFieldId = (form: Form, fieldId: string): [string, number] => {
  const valueIndex = form?.values.findIndex((f) => {
    return f.fieldId === fieldId;
  });

  // handle when a form is reloaded over and over again.
  // i.e. public form or hipaa
  if (typeof valueIndex !== 'number') {
    return undefined;
  }

  if (valueIndex === -1) {
    return null;
  }

  return ['values', valueIndex];
};

export const getValue = (form: Form, fieldId: string): TypeMePlease => {
  const keyPath = getValueKeyPathByFieldId(form, fieldId);
  if (!keyPath) {
    return null;
  }
  return getIn(form, keyPath);
};

export const getValueByFieldName = (template: Template, form: Form, fieldName: string) => {
  const fieldId = getFieldIdByName(template, fieldName);
  if (fieldId) {
    const value = getValue(form, fieldId);
    if (value) {
      return value.value;
    }
  }
  return null;
};

export const getFormulaValue = (formulaValues: Record<string, TypeMePlease>, id: string, key: string) => {
  const formulaKey = `${id}_${key}`;
  if (formulaValues && formulaValues[formulaKey] !== undefined) {
    return {
      hasFormula: true,
      value: formulaValues[formulaKey]
    };
  }
  return { hasFormula: false, value: null };
};

export const getSendAFormState = (state: RootState): SendAForm => state.formeditor?.sendAForm ?? { interactive: true, selectedFieldPositionIds: [] };
